import HomeTemplate from "../../../templates/users/home";

const HomeScreen = () => {
  return <HomeTemplate />;
};

export default HomeScreen;
